import React, { Fragment, useState, useEffect } from 'react';
import {
    Row,
    FormGroup,
    Label,
    Col,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Spinner,
    Modal, ModalHeader,
    ModalBody, ModalFooter, Button
} from 'reactstrap';
import Axios from 'axios';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    week,
    month,
    last7Days,
    last30Days,
    last60Days,
    last90Days,
    LastDays,
    year,
} from './lablesConfig';
import {
    API_RegionGroups_Stats,
    gAPI_Conversation_Hourly_Stats
} from '../../../../../constants/APIs';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import ConversationHourlyChartCard from './DetailedDataStats/ConversationHourlyChartCard';
import Region from './DetailedDataStats/Region';


const regionDataTableColumns = [
    {
        Header: 'Region',
        accessor: 'region',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
        Header: <IntlMessages id='dashboards.webVisitors' />,
        accessor: 'visitors',
        Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
    {
        Header: <IntlMessages id='dashboards.avatarClicks' />,
        accessor: 'botClicks',
        Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
    {
        Header: <IntlMessages id='menu.conversations' />,
        accessor: 'conversations',
        Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
];

export default function DetailedDataCard({
    propertyId,
    isVoucherEngine,
    timeZone,
    domains,
    currency,
    history,
    integrationIdList, hideStats
}) {
    moment.tz.setDefault(timeZone);
    const [buttonText, setButtonText] = useState(
        <IntlMessages id="dashboards.last-7-days" />
    );
    const [labels, setLabels] = useState(last7Days);
    const [isShow, setIsShow] = useState(false);
    const [isError, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [filterDate, setFilterDate] = useState(false);
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [fromDate, setfromDate] = useState('');
    const [toDate, settoDate] = useState('');
    const [isHourly, setIsHourly] = useState(true);
    const [conversationHourlyStatsData, setConversationHourlyStatsData] = useState([]);
    const [isRegion, setIsRegion] = useState(false);
    const [regionStatsData, setRegionStatsData] = useState([]);
    const [conversationError, setConversationError] = useState(null);
    const [regionError, setRegionError] = useState(null);

    const StatContainer = ({ onRefresh, error, children }) => {
        return (
            <div>
                {error ? (
                    <Card className="text-center my-3" style={{ padding: '100px' }}>
                        <p style={{ color: 'red' }}>{error}</p>

                        <i className='iconsminds-refresh' style={{ fontSize: '40px', color: 'grey' }}
                            onClick={onRefresh}
                        />


                    </Card>
                ) : (
                    children
                )}
            </div>
        );
    };
    const fetchConversationStats = async (fromDate, toDate) => {
        setConversationError(null);
        setIsHourly(true);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${gAPI_Conversation_Hourly_Stats}`,
                params: {
                    groupId: getGroupID(),
                    propertyId,
                    dateFrom: fromDate,
                    dateTo: toDate,
                },
            });
            setIsHourly(false);
            setConversationHourlyStatsData(res.data);
        } catch (error) {
            console.error('error', error, error?.response?.data);
            setConversationError('Failed to load Conversation stats.');
        }
    };

    const fetchRegionStats = async (fromDate, toDate) => {
        setRegionError(null);
        setIsRegion(true);
        console.log("Region stats:", {
            groupId: getGroupID(),
            dateFrom: fromDate,
            dateTo: toDate,
            propertyId,
            integrationIds: integrationIdList,
        });
        try {
            const res = await AxiosAPI({
                method: 'post',
                url: `${API_RegionGroups_Stats}`,
                data: {
                    groupId: getGroupID(),
                    dateFrom: fromDate,
                    dateTo: toDate,
                    propertyId,
                    integrationIds: integrationIdList,
                },
            });
            setIsRegion(false);
            setRegionStatsData(res.data);
        } catch (error) {
            console.error('error', error, error?.response?.data);
            setRegionError('Failed to load Region stats.');
        }
    };

    const today = () => {
        return moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const daysAgo7 = () => {
        return moment(moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo30 = () => {
        return moment(moment().subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo60 = () => {
        return moment(moment().subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo90 = () => {
        return moment(moment().subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfWeek = () => {
        const today = moment();
        return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const endOfWeek = () => {
        const today = moment();
        return moment(
            moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfMonth = () => {
        return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
            ' 00:00:00'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfThisYear = () => {
        return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const startOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
            ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const endOfMonth = () => {
        return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const handleStartDate = (date) => {
        setStartDate(moment(date))
    };

    const handleEndDate = (date) => {
        setEndDate(moment(date))
    };


    useEffect(() => {
        if (propertyId !== '' && propertyId !== undefined) {
            selectLast7Days();

        }
    }, [propertyId]);

    const selectDateRange = (from, to, intlId) => {
        setFilterDate(false);
        setButtonText(<IntlMessages id={intlId} />);
        // setLabels(labelSet);
        setfromDate(from);
        settoDate(to);

        fetchConversationStats(from, to);
        fetchRegionStats(from, to);
    };
    const selectLast7Days = () => {
        setLabels(last7Days);
        selectDateRange(daysAgo7(), today(), "dashboards.last-7-days");
    };

    const selectLast30Days = () => {
        setLabels(last30Days);
        selectDateRange(daysAgo30(), today(), "dashboards.last-30-days");
    };

    const selectLast60Days = () => {
        setLabels(last60Days);
        selectDateRange(daysAgo60(), today(), "dashboards.last-60-days");
    };

    const selectLast90Days = () => {
        setLabels(last90Days);
        selectDateRange(daysAgo90(), today(), "dashboards.last-90-days");
    };

    const selectThisWeek = () => {
        setLabels(week);
        selectDateRange(startOfWeek(), endOfWeek(), "dashboards.this-week");
    };

    const selectThisMonth = () => {
        setLabels(month);
        selectDateRange(startOfMonth(), endOfMonth(), "dashboards.this-month");
    };

    const selectPreviousMonth = () => {
        setLabels(month);
        selectDateRange(startOfPreviousMonth(), endOfPreviousMonth(), "dashboards.previous-month");
    };

    const selectThisYear = () => {
        setLabels(year);
        selectDateRange(startOfThisYear(), today(), "dashboards.yeartodate");
    };

    const selectLastYear = () => {
        setLabels(year);
        selectDateRange(startOfLastYear(), endOfLastYear(), "dashboards.lastyear");
    };


    const handleFilterDateWise = (start, end) => {
        setfromDate(daysAgo90());
        settoDate(today());

        fetchConversationStats(start, end);
        fetchRegionStats(start, end);
    };
    const handleFilterMonthWise = (start, end) => {
        setLabels(year);
        setfromDate(startOfLastYear());
        settoDate(endOfLastYear());

        fetchConversationStats(start, end);
        fetchRegionStats(start, end);
    };

    const handleFilter = () => {
        let diff = endDate.diff(startDate, 'days');
        setButtonText('Date Range');
        if (diff > 365) {
            setMessage("The start and end date must be within a year of each other.");
            setError(true);
            return;
        }
        if (diff > 90) {
            setIsShow(false);
            setLabels(year);
            handleFilterMonthWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);

        } else {
            if (diff >= 60)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 30)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 7)
                setLabels(LastDays(startDate, endDate));
            else
                setLabels(LastDays(startDate, endDate));
            setIsShow(false);
            handleFilterDateWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);
        }
    };

    return (
        <Fragment>
            <Row>
                <Col xxs="12" className="mb-2">
                    <Fragment>
                        {filterDate === true && <div className='float-left mt-2'>
                            <span className='mr-2'><b>From : </b>{moment(startDate).format('DD')}/{moment(startDate).format('MM')}/{moment(startDate).format('YYYY')}</span>
                            <span className='ml-2'><b>To : </b>{moment(endDate).format('DD')}/{moment(endDate).format('MM')}/{moment(endDate).format('YYYY')}</span>
                        </div>}
                        <div className="btn-group float-right float-none-xs mb-3">
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret
                                    color="primary"
                                    className="btn-xs"
                                    outline
                                >
                                    {buttonText}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={selectLast7Days}>
                                        <IntlMessages id="dashboards.last-7-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast30Days}>
                                        <IntlMessages id="dashboards.last-30-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast60Days}>
                                        <IntlMessages id="dashboards.last-60-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast90Days}>
                                        <IntlMessages id="dashboards.last-90-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisWeek}>
                                        <IntlMessages id="dashboards.this-week" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisMonth}>
                                        <IntlMessages id="dashboards.this-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectPreviousMonth}>
                                        <IntlMessages id="dashboards.previous-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisYear}>
                                        <IntlMessages id="dashboards.yeartodate" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLastYear}>
                                        <IntlMessages id="dashboards.lastyear" />
                                    </DropdownItem>
                                    <DropdownItem onClick={() => setIsShow(!isShow)}>
                                        <IntlMessages id="form-components.date-range" />
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </Fragment>
                </Col>
            </Row>
            <Row>
                {hideStats !== null && hideStats.isRegionalLevel === true && (
                    <Col sm="12" md="6" className="mb-4">
                        <StatContainer
                            error={regionError}
                            onRefresh={() => fetchRegionStats(fromDate, toDate)}
                        >
                            {isRegion === true ? (
                                <div className="text-center loading" />
                            ) : (
                                <Region
                                    labels={regionDataTableColumns}
                                    data={regionStatsData}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                />)
                            }
                        </StatContainer>
                    </Col>
                )}
                {hideStats !== null && hideStats.isHourlyConversation === true && (
                    <Col sm="12" md="6" className="mb-4">
                        <StatContainer
                            error={conversationError}
                            onRefresh={() => fetchConversationStats(fromDate, toDate)}
                        >
                            {isHourly === true ? (
                                <div className="text-center loading" />
                            ) : (<ConversationHourlyChartCard
                                conversationHourly={conversationHourlyStatsData}
                            />)
                            }
                        </StatContainer>
                    </Col>
                )}

            </Row>

            <Modal isOpen={isShow}
                toggle={() => setIsShow(!isShow)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setIsShow(!isShow)}>
                    <IntlMessages id="form-components.date-range" />
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label><IntlMessages id='dashboards.start-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: "10px" }}
                                    selected={startDate ? new Date(startDate) : null} // ensure Date object
                                    onChange={handleStartDate}
                                    placeholderText="Start Date"
                                    dateFormat="dd/MM/yyyy"   // ✅ correct format
                                />
                            </FormGroup>
                        </Colxx>

                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label> <IntlMessages id='dashboards.end-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: "10px" }}
                                    selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                                    onChange={handleEndDate}
                                    placeholderText="End Date"
                                    dateFormat="dd/MM/yyyy"   // ✅ correct format
                                />
                            </FormGroup>
                        </Colxx>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button color='primary' onClick={() => handleFilter()}>Submit</Button>
                    <Button className="ml-2" onClick={() => setIsShow(!isShow)}>Close</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isError}
                toggle={() => setError(!isError)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setError(!isError)}>
                    BOOKMEBOB
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <p className='m-2'>{message}</p>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button className="ml-2" onClick={() => setError(!isError)}>Close</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}